var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "table unit_group", staticStyle: { "overflow-x": "auto" } },
    _vm._l(_vm.rowText, function (row, rowIndex) {
      return _c(
        "div",
        {
          directives: [
            { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
          ],
          key: rowIndex,
          staticClass: "row",
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: 1,
                  expression: "1",
                },
              ],
              staticStyle: { "min-width": "200px" },
            },
            [_vm._v(" " + _vm._s(row) + " ")]
          ),
          _vm._l(_vm.data, function (col, colIndex) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: 1,
                    expression: "1",
                  },
                ],
                key: colIndex,
              },
              [
                _c("div", [
                  _c(
                    "div",
                    {
                      key: _vm.flagSourceThermalGeneration,
                      attrs: {
                        title: col.sourceBlockNameSid
                          ? _vm.$t(
                              `operationalData.entryView.tabs.dropDownOptions.${col.sourceBlockNameSid}`
                            )
                          : _vm.$t("placeholder"),
                      },
                    },
                    [
                      rowIndex == 1
                        ? _c("pui-form-select", {
                            staticClass: "thermal_input mt-1 mb-1",
                            attrs: {
                              label: "Source of Thermal Generation",
                              id: "thermalBuildingBlockName-" + colIndex,
                              options: _vm.options,
                              "search-input-placeholder": _vm.$t("placeholder"),
                              "is-valid": _vm.isValidName(col),
                              "is-disabled": _vm.isReadOnly,
                            },
                            on: { change: _vm.atInputChange },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (slotProps) {
                                    return [
                                      _c("pui-list-option", {
                                        staticClass: "dropDown_options",
                                        attrs: {
                                          label:
                                            slotProps.option.shortenedLabel,
                                          title: slotProps.option.label,
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: col.sourceBlockNameSid,
                              callback: function ($$v) {
                                _vm.$set(col, "sourceBlockNameSid", $$v)
                              },
                              expression: "col.sourceBlockNameSid",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                rowIndex == 2
                  ? _c("custom-input", {
                      staticClass: "thermal_input mt-1 mb-1",
                      attrs: {
                        required: false,
                        min: 0,
                        precision: _vm.precision,
                        "is-disabled": _vm.isReadOnly,
                        readonly: _vm.isReadOnly,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.atInputChange(colIndex, rowIndex - 1)
                        },
                      },
                      model: {
                        value: col.grossHeatGenerationVolume,
                        callback: function ($$v) {
                          _vm.$set(col, "grossHeatGenerationVolume", $$v)
                        },
                        expression: "col.grossHeatGenerationVolume",
                      },
                    })
                  : _vm._e(),
                rowIndex == 3
                  ? _c("custom-input", {
                      staticClass: "thermal_input mt-1 mb-1",
                      attrs: {
                        "is-disabled": _vm.isReadOnly,
                        readonly: _vm.isReadOnly,
                        required: _vm.isRequired(colIndex),
                        min: 0,
                        precision: _vm.precision,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.atInputChange(colIndex, rowIndex - 1)
                        },
                      },
                      model: {
                        value: col.netHeatGenerationVolume,
                        callback: function ($$v) {
                          _vm.$set(col, "netHeatGenerationVolume", $$v)
                        },
                        expression: "col.netHeatGenerationVolume",
                      },
                    })
                  : _vm._e(),
                rowIndex == 4
                  ? _c("custom-input", {
                      staticClass: "thermal_input mt-1 mb-1",
                      attrs: {
                        "is-disabled": _vm.isReadOnly,
                        readonly: _vm.isReadOnly,
                        required: _vm.isRequired(colIndex),
                        min: 0,
                        precision: 5,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.atInputChange(colIndex, rowIndex - 1)
                        },
                      },
                      model: {
                        value: col.powerFactor,
                        callback: function ($$v) {
                          _vm.$set(col, "powerFactor", $$v)
                        },
                        expression: "col.powerFactor",
                      },
                    })
                  : _vm._e(),
                rowIndex == 5
                  ? _c("custom-input", {
                      staticClass: "thermal_input mt-1 mb-1",
                      attrs: {
                        "is-disabled": true,
                        readonly: true,
                        precision: 3,
                      },
                      model: {
                        value: col.electricEquivalentVolume,
                        callback: function ($$v) {
                          _vm.$set(col, "electricEquivalentVolume", $$v)
                        },
                        expression: "col.electricEquivalentVolume",
                      },
                    })
                  : _vm._e(),
                rowIndex == 0 && colIndex != 0
                  ? _c("pui-lightbox", {
                      ref: "confirmDeletionModalRef",
                      refInFor: true,
                      staticClass: "modal",
                      attrs: {
                        state: "secondary",
                        "default-header-label": _vm.$t(
                          "operationalData.entryView.tabs.thermalGen.confirmDeletionPopupHeader"
                        ),
                        "fit-content": true,
                        fullscreen: false,
                        "close-on-overlay-click": true,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "lightbox-trigger",
                            fn: function () {
                              return [
                                _c("pui-button", {
                                  staticClass: "button__delete",
                                  attrs: {
                                    "icon-only": true,
                                    icon: "delete",
                                    disabled: _vm.isReadOnly,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openConfirmDeletionPopup(
                                        colIndex
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "mt-3 mb-3" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "operationalData.entryView.tabs.thermalGen.confirmDeletionPopupText"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "lightbox-footer",
                            fn: function () {
                              return [
                                _c(
                                  "pui-button",
                                  {
                                    attrs: { state: "secondary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteColumn(colIndex)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "defaultValidityModalConfirmLabel"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "pui-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.closeConfirmDeletionPopup(
                                          colIndex
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                rowIndex == 0 && colIndex == 0
                  ? _c("div", { staticStyle: { width: "200px" } })
                  : _vm._e(),
              ],
              1
            )
          }),
          rowIndex == 1
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: 1,
                      expression: "1",
                    },
                  ],
                },
                [
                  _vm.data.length < _vm.maxBuildingBlocksCount
                    ? _c(
                        "pui-button",
                        {
                          attrs: {
                            id: "addSourceButton",
                            disabled: _vm.isReadOnly,
                          },
                          on: { click: _vm.addColumn },
                        },
                        [
                          _c("pui-icon", { attrs: { "icon-name": "add" } }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "operationalData.entryView.tabs.thermalGen.addSource"
                                )
                              ) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          rowIndex > 1
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: 1,
                      expression: "1",
                    },
                  ],
                },
                [_vm._v(" " + _vm._s(_vm.units[rowIndex - 2]) + " ")]
              )
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }